import { ConfigFormData } from '@/models/onboarding';

export function validation(formData: ConfigFormData) {
  switch (formData.type) {
    case 'custom':
      return !isNaN(parseInt(String(formData.customValue)));

    case 'default':
      return !isNaN(parseInt(String(formData.value)));

    default:
      return false;
  }
}
